import React from "react";
import { Link } from "react-router-dom";

import { Grid } from "@material-ui/core";
import { APP_ROUTES, NEW_PATH_SELECTED } from "../../../config/constants";

import PrimaryButton from "../../common/PrimaryButton/PrimaryButton";
import { isEmptyOrNull } from "utils/DataUtils";

interface CountrySettingsFooterInterface {
  classes: any;
  handleApplyChangesClick: any;
}

const CountrySettingsFooter = (props: CountrySettingsFooterInterface) => {
  const { classes, handleApplyChangesClick } = props;
  const newPathSelectedOnSideMenu = localStorage.getItem(NEW_PATH_SELECTED);
  const targetPath = !isEmptyOrNull(newPathSelectedOnSideMenu) ? newPathSelectedOnSideMenu : APP_ROUTES.POS_LIST;
  return (
    <Grid container justifyContent="flex-end" spacing={2} className={classes.footerGridContainer}>
      <Grid item>
        <Link to={`${targetPath}`} style={{ textDecoration: "none" }}>
          <PrimaryButton buttonLabel="Back to DOS" buttonVariant="outlined" />
        </Link>
      </Grid>
      <Grid item>
        <PrimaryButton buttonLabel="APPLY CHANGES" onClick={handleApplyChangesClick} />
      </Grid>
    </Grid>
  );
};

export default React.memo(CountrySettingsFooter);
